import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index.js";

/* auth */
import Login from "../views/auth/Login.vue";
import ForgotPassword from "../views/auth/ForgotPassword";
import ForgotPasswordEmailSent from "../views/auth/ForgotPasswordEmailSent";
import SetNewPassword from "../views/auth/SetNewPassword";
import SetNewPasswordSuccess from "../views/auth/SetNewPasswordSuccess";
/* Blog */
import BlogPosts from "../views/blog/BlogPosts";
import EditPost from "../views/blog/EditPost";
import NewPost from "../views/blog/NewPost";
import Tags from "../views/blog/Tags";
import Categories from "../views/blog/Categories";
import PostComments from "../views/blog/PostComments";
import NewComment from "../views/blog/NewComment";
import Reviews from "../views/blog/Reviews";
import PageReviews from "../views/blog/PageReviews";
import NewReview from "../views/blog/NewReview";
import Git from "../views/blog/Git";

import NotFound from "../views/404";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
    meta: {
      guest: true
    }
  },
  {
    path: "/password-changed",
    name: "Password changed",
    component: SetNewPasswordSuccess,
    meta: {
      guest: true
    }
  },

  {
    path: "/forgot-password",
    name: "Forgot password",
    component: ForgotPassword,
    meta: {
      guest: true
    }
  },

  {
    path: "/forgot-password-email-sent",
    name: "Forgot password email sent",
    component: ForgotPasswordEmailSent,
    meta: {
      guest: true
    }
  },
  {
    path: "/set-new-password/:token",
    name: "Set new password",
    component: SetNewPassword,
    meta: {
      guest: true
    }
  },
  {
    path: "/posts",
    name: "Posts",
    component: BlogPosts,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/posts/new",
    name: "New blog post",
    component: NewPost,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/posts/:id",
    name: "Edit blog post",
    component: EditPost,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/tags",
    name: "Tags",
    component: Tags,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/reviews",
    name: "Reviews",
    component: Reviews,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/reviews/:pageSlug",
    name: "Page reviews",
    component: PageReviews,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/reviews/new/:pageSlug",
    name: "New review",
    component: NewReview,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/categories",
    name: "Categories",
    component: Categories,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/post/:postId/comments",
    name: "Post comments",
    component: PostComments,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/post/:postId/comments/new",
    name: "New comment",
    component: NewComment,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: "/git",
    name: "Git",
    component: Git,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "*",
    name: "Page not found",
    component: NotFound
  }
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next();
      return;
    }
    next("/");
  } else if (to.matched.some(record => record.meta.guest)) {
    if (!store.getters.isLoggedIn) {
      next();
    } else {
      next({ name: "Posts" });
    }
  } else {
    next();
  }
});

export default router;
